import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ReBaseData } from '../../../../shared/utils/re-base-data';
import { TRACKING } from '../../../enums/trackingParts.enum';

@Component({
    selector: 'bdo-more-services-tile',
    templateUrl: './more-services-tile.component.html',
    styleUrls: ['./more-services-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MoreServicesTileComponent {
  @Input() isRestricted: boolean = false;
  @Input() accountId: string;
  public TRACKING = TRACKING;
  public linkToSelection: boolean = true;
  protected reBaseData = ReBaseData;

  constructor() { }

}
